export const _count_services = [1, 1, 1, 1, 1, 1, 1]
